import React, { useEffect } from 'react';
import "react-loading-skeleton/dist/skeleton.css";
import CenteredSkeleton from './common/CenteredSkeleton.jsx';

const FormEditorSkeleton = () => {
  const resize = () => {
    let editor = jQuery('.form-editor');

    if (editor.length > 0) {
      let bottomPadding = jQuery(window).width() < 768 ? 130 : 60;
      editor.find('.panes').css({
        height: (jQuery(window).height() - editor.offset().top - editor.find('.bottom').outerHeight(true) - bottomPadding) + 'px'
      });
    }
  }

  useEffect(() => {
    resize();
  }, [])

  return (
    <div className='form-editor'>
      <div className='panes'>
        <div className='splitter-cell' style={{width: '30%'}}>
          <CenteredSkeleton width='99%' height='100%'/>
        </div>
        <div className='splitter-cell' style={{width: '40%'}}>
          <CenteredSkeleton width='99%' height='100%'/>
        </div>
        <div className='splitter-cell' style={{width: '30%'}}>
          <CenteredSkeleton width='99%' height='100%'/>
        </div>
      </div>
    </div>
  )
}

export default FormEditorSkeleton;